/*
 * Gold Blocking — Complete Solution
 *
 * Pricing rule: text lines, instrument/voice and logo/crest are charged per folder.
 * The custom-die fee is a one-off for the whole order — never multiplied by the
 * folder quantity — and is waived when the customer ticks gb_die_on_file, i.e. we
 * already hold the artwork from a die made for them in the past. The per-folder
 * impression (UK £3.00, Germany €2.50) is still charged. Neither figure is replaced
 * by the £10 / €10 minimum, which applies only to text lines and instrument/voice.
 */

(function () {

  /**
   * Per-market price lists. The German prices are not a conversion of the UK ones — the printed
   * German list quotes its own figures (€115 die, €2.50 per impression), so both are held here
   * and picked per market. Amounts are plain numbers; formatGbMoney() adds £ or €.
   */
  const PRICES_UK = {
    textLine:   2.50,
    instrument: 5.00,
    logo:       3.00,   // per impression per folder
    newDie:   105.00,   // one-off, per logo or crest
    minimum:   10.00
  };

  const PRICES_DE = {
    textLine:   2.50,   // TODO confirm against the German price list
    instrument: 5.00,   // TODO confirm against the German price list
    logo:       2.50,   // 2,50 € pro Druck und Ordner
    newDie:   115.00,   // 115,00 € pro Logo oder Wappen für die Herstellung einer individuellen Stanzform
    minimum:   10.00    // TODO confirm against the German price list
  };

  function gbPrices() {
    return isDeMarket() ? PRICES_DE : PRICES_UK;
  }

  /** Both die prices, so a Globo addon line is recognised whichever market's set configured it. */
  const DIE_ADDON_PRICES = [PRICES_UK.newDie, PRICES_DE.newDie];

  /** Shown on cart line items / drawer; reflects full gold-blocking total for the line. */
  const GB_CART_TOTAL_PROPERTY = 'Gold-Blocking Total';

  const FORM_BLOCK_ID = 'shopify-block-AYU15TVVMUGdMN2N2U__globo_product_options_app_block_gki7cQ';

  const STRINGS_EN = {
    textLines: 'Text Lines',
    instrument: 'Instrument/Voice',
    logo: 'Logo/Crest',
    newDie: 'New Die Manufacture',
    minCharge: 'Minimum gold-blocking charge {min} applies (options subtotal {raw}).',
    minChargeRow: 'Minimum gold-blocking charge',
    minChargeNote: 'Selected options subtotal {raw}.',
    applied: '✅ Gold-Blocking Applied',
    total: 'Gold-Blocking Total:',
    selectOption: 'Please select at least one gold-blocking option first.',
    fileRestored: 'Previously uploaded:',
    reupload: '(Re-upload if you want to change)',
    applyButton: 'Apply Gold-Blocking',
    cancelButton: 'Cancel',
    popupSubtotal: 'Subtotal for gold-blocking:',
    perItem: 'Subtotal per item',
    oneOff: '(one-off)'
  };

  const STRINGS_DE = {
    textLines: 'Textzeilen',
    instrument: 'Instrument/Stimme',
    logo: 'Logo/Wappen',
    newDie: 'Neue individuelle Stanzform',
    minCharge: 'Mindestgebühr für Goldprägung {min} (Zwischensumme der Optionen {raw}).',
    minChargeRow: 'Mindestgebühr für Goldprägung',
    minChargeNote: 'Zwischensumme der ausgewählten Optionen {raw}.',
    applied: '✅ Goldprägung angewendet',
    total: 'Goldprägung gesamt:',
    selectOption: 'Bitte wählen Sie zuerst mindestens eine Goldprägungsoption aus.',
    fileRestored: 'Zuvor hochgeladen:',
    reupload: '(Erneut hochladen zum Ändern)',
    applyButton: 'Goldprägung anwenden',
    cancelButton: 'Abbrechen',
    popupSubtotal: 'Zwischensumme für Goldprägung:',
    perItem: 'Zwischensumme pro Artikel',
    oneOff: '(einmalig)'
  };

  /** Native DE Globo option set (Goldblockierung) — separate from theme JS translations. */
  const GLOBO_DE_NATIVE_APPLY = [
    'GOLDBLOCKIERUNG ANWENDEN',
    'Goldblockierung anwenden',
    'Goldblockierung Anwenden'
  ];

  const GLOBO_DE_NATIVE_CANCEL = ['STORNIEREN', 'Stornieren'];

  /** Longest-first Globo popup label replacements (EN → DE). */
  const GLOBO_TEXT_MAP_DE = [
    ['Apply Gold-Blocking', 'Goldprägung anwenden'],
    ['Apply Gold Blocking', 'Goldblockierung anwenden'],
    ['Gold-Blocking Options', 'Goldprägungsoptionen'],
    ['Gold Blocking Options', 'Goldprägungsoptionen'],
    ['Instrument/Voice Illustration', 'Instrument-/Stimmabbildung'],
    ['Upload Instrument/Voice Illustration', 'Instrument-/Stimmabbildung hochladen'],
    ['Upload Logo/Crest', 'Logo/Wappen hochladen'],
    ['New Die Manufacture', 'Herstellung einer individuellen Stanzform'],
    ['New die manufacture', 'Herstellung einer individuellen Stanzform'],
    ['Die on file (no charge)', 'Stanzform vorhanden (keine Gebühr)'],
    ['Die on file', 'Stanzform vorhanden'],
    ['I have a die on file', 'Stanzform ist vorhanden'],
    ['Text Line 3', 'Textzeile 3'],
    ['Text Line 2', 'Textzeile 2'],
    ['Text Line 1', 'Textzeile 1'],
    ['Line 3', 'Zeile 3'],
    ['Line 2', 'Zeile 2'],
    ['Line 1', 'Zeile 1'],
    ['Instrument/Voice', 'Instrument/Stimme'],
    ['Logo/Crest', 'Logo/Wappen'],
    ['or drop file', 'oder Datei ablegen'],
    ['Choose file', 'Datei auswählen'],
    ['Browse', 'Durchsuchen'],
    ['Required', 'Pflichtfeld'],
    ['Cancle', 'Abbrechen'],
    ['Cancel', 'Abbrechen']
  ];

  const GLOBO_FIELD_LABELS_DE = {
    gb_line_1: 'Textzeile 1',
    gb_line_2: 'Textzeile 2',
    gb_line_3: 'Textzeile 3',
    gb_instrument_file: 'Instrument-/Stimmabbildung hochladen',
    gb_logo_file: 'Logo/Wappen hochladen',
    gb_instrument_charge: 'Instrument/Stimme',
    gb_logo_charge: 'Logo/Wappen'
  };

  /**
   * Copy for the gb_die_on_file checkbox. Ticked = we already hold the customer's artwork,
   * so the one-off new-die fee is waived and only the per-impression logo/crest fee applies.
   * Globo renders this label from its own settings, so the theme rewrites it to keep the
   * wording in step with the charge calculated below.
   */
  const DIE_ON_FILE_COPY_EN =
    'Please tick this box if we already have your artwork on file (i.e. we have created a die ' +
    'for your school or company in the past). In this case you will <strong>not</strong> be ' +
    'charged the {die} for manufacture of new custom die. You will only be charged the ' +
    '{impression} per impression per folder.';

  const DIE_ON_FILE_COPY_DE =
    'Bitte kreuzen Sie dieses Feld an, wenn uns Ihre Vorlage bereits vorliegt (d. h. wir haben in ' +
    'der Vergangenheit eine Stanzform für Ihre Schule oder Ihr Unternehmen angefertigt). In diesem ' +
    'Fall werden Ihnen die {die} für die Herstellung einer neuen individuellen Stanzform ' +
    '<strong>nicht</strong> berechnet. Berechnet werden nur {impression} pro Druck und Ordner.';

  /** Filled from the market's own price list, so the wording can never drift from the charge. */
  function dieOnFileCopy() {
    const price = gbPrices();
    return (isDeMarket() ? DIE_ON_FILE_COPY_DE : DIE_ON_FILE_COPY_EN)
      .replace('{die}', formatGbMoney(price.newDie))
      .replace('{impression}', formatGbMoney(price.logo));
  }

  /** Matches the old and the new wording, so the label is found whichever one Globo renders. */
  const DIE_ON_FILE_COPY_PATTERN =
    /tick this box|kreuzen sie dieses feld|artwork on file|create your artwork|die for your school|Vorlage bereits vorliegt/i;

  let listenersAttached = false;
  let cartSyncDone      = false;
  /** Ignores Apply-from-radio briefly while the Globo block is moved into the modal (can emit a stray `change`). */
  let suppressApplyFromRadio = false;

  // ─── Locale ─────────────────────────────────────────────────
  function isDeMarket() {
    if (window.goldBlockingLocale && window.goldBlockingLocale.isDe) return true;
    if (document.body && document.body.classList.contains('is-de-market')) return true;
    return window.location.pathname.indexOf('/de/') !== -1;
  }

  function getVatSuffix() {
    if (window.VatDisplay && typeof window.VatDisplay.getSuffix === 'function') {
      return window.VatDisplay.getSuffix();
    }
    return isDeMarket() ? '+Mwst' : '+VAT';
  }

  function roundMoney(amount) {
    return Math.round(Number(amount) * 100) / 100;
  }

  /** Add-on charge = max(quantity × per-unit add-on price, minimum charge). */
  function getGoldBlockingTotal(raw, qty) {
    if (!raw || raw <= 0) return 0;
    qty = Math.max(1, qty);
    const calculated = roundMoney(raw * qty);
    const minimum = gbPrices().minimum;
    return calculated < minimum ? minimum : calculated;
  }

  function minChargeApplies(raw, qty) {
    if (!raw || raw <= 0) return false;
    qty = Math.max(1, qty);
    return roundMoney(raw * qty) < gbPrices().minimum;
  }

  function parseGbAddonValue(raw) {
    if (!raw) return null;
    try {
      const cleaned = String(raw).replace(/&quot;/g, '"');
      const items = JSON.parse(cleaned);
      return Array.isArray(items) && items.length ? items : null;
    } catch (e) {
      return null;
    }
  }

  /** Distribute a target addon subtotal (in pence) across Globo addon lines. */
  function distributeAddonTotalCents(items, targetCents) {
    const units = [];
    items.forEach(function (item) {
      const q = item._gbBaseQ;
      const unitCents = Math.max(0, Math.round(item._gbPrice * 100));
      for (let u = 0; u < q; u++) {
        units.push({ item: item, weight: unitCents });
      }
    });

    if (!units.length) return;

    const totalWeight = units.reduce(function (sum, unit) {
      return sum + unit.weight;
    }, 0);

    let allocated = 0;
    units.forEach(function (unit, idx) {
      let cents;
      if (idx === units.length - 1) {
        cents = targetCents - allocated;
      } else if (totalWeight > 0) {
        cents = Math.floor(targetCents * unit.weight / totalWeight);
      } else {
        cents = Math.floor(targetCents / units.length);
      }
      allocated += cents;
      unit.cents = cents;
    });

    items.forEach(function (item) {
      const itemUnits = units.filter(function (unit) {
        return unit.item === item;
      });
      const itemTotalCents = itemUnits.reduce(function (sum, unit) {
        return sum + unit.cents;
      }, 0);
      item._gbPrice = itemTotalCents / item._gbBaseQ / 100;
    });
  }

  /** The one-off die fee has its own Globo addon line, priced apart from the per-folder options. */
  function isNewDieAddonItem(item) {
    return DIE_ADDON_PRICES.some(function (price) {
      return Math.abs(Number(item._gbBasePrice) - price) < 0.005;
    });
  }

  /**
   * Globo multiplies addon subtotals by cart line quantity, so addon prices are set to each
   * folder's share of the gold-blocking charge and the line total then matches calculate().total.
   * The £105 die fee is spread across the line rather than charged per folder, because it is a
   * one-off for the whole order — and drops to zero when the customer's die is already on file.
   */
  function processGbAddonItems(items) {
    if (!Array.isArray(items) || !items.length) return items;

    items.forEach(function (item) {
      if (item._gbBasePrice == null) {
        item._gbBasePrice = roundMoney(Number(item.p || 0));
      }
      if (item._gbBaseQ == null) {
        item._gbBaseQ = Math.max(1, Number(item.q || 1));
      }
      item._gbPrice = item._gbBasePrice;
    });

    const d = calculate();
    if (!d.isActive) return items;

    const cartQty = Math.max(1, d.qty);
    const targetAddonCents = Math.round(d.total * 100 / cartQty);

    const dieItems = items.filter(isNewDieAddonItem);
    const perFolderItems = items.filter(function (item) { return !isNewDieAddonItem(item); });

    let dieCents = 0;
    if (dieItems.length && d.dieCh > 0) {
      dieCents = Math.min(Math.round(d.dieCh * 100 / cartQty), targetAddonCents);
    }

    if (!perFolderItems.length) {
      distributeAddonTotalCents(dieItems, targetAddonCents);
    } else {
      if (dieItems.length) distributeAddonTotalCents(dieItems, dieCents);
      distributeAddonTotalCents(perFolderItems, Math.max(0, targetAddonCents - dieCents));
    }

    items.forEach(function (item) {
      item.p = item._gbPrice.toFixed(2);
      item.q = item._gbBaseQ;
    });

    return items;
  }

  function getGbAddonProductsInput(form) {
    const scope = form || document.querySelector('.product-form, form[action*="/cart/add"]');
    if (!scope) return null;
    return scope.querySelector('input[name="properties[_gpo_addon_products]"]');
  }

  function processGbAddonInput(form) {
    const input = getGbAddonProductsInput(form);
    if (!input || !input.value) return null;

    const items = parseGbAddonValue(input.value);
    if (!items) return null;

    processGbAddonItems(items);
    input.value = JSON.stringify(items);
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    return items;
  }

  function applyGbAddonToFormData(fd) {
    const raw = fd.get('properties[_gpo_addon_products]');
    if (!raw) return;
    const items = parseGbAddonValue(raw);
    if (!items) return;
    processGbAddonItems(items);
    fd.set('properties[_gpo_addon_products]', JSON.stringify(items));
  }

  function applyGbAddonToUrlParams(params) {
    const raw = params.get('properties[_gpo_addon_products]');
    if (!raw) return;
    const items = parseGbAddonValue(raw);
    if (!items) return;
    processGbAddonItems(items);
    params.set('properties[_gpo_addon_products]', JSON.stringify(items));
  }

  function updateGbPriceSummaryTotal() {
    refreshPriceSummary();
  }

  /** Rebuilt wholesale: a quantity change can switch the minimum charge on or off. */
  function refreshPriceSummary() {
    const summary = document.getElementById('gb-price-summary');
    if (!summary) return;

    const d = calculate();
    if (!d.isActive) return;

    summary.innerHTML = buildPriceSummaryHtml(d);
    localizeDeCartCurrency(document);
  }

  function scheduleProcessGbAddonInput() {
    setTimeout(function () {
      processGbAddonInput();
      updateGbPriceSummaryTotal();
    }, 300);
  }

  /** Base variant price only — Globo must not add gold-blocking fees here. */
  let basePriceSnapshot = null;
  let suppressPriceObserver = false;
  let priceStabilizeScheduled = false;
  const priceObservers = [];

  function hasGoldBlockingProduct() {
    return !!(document.getElementById(FORM_BLOCK_ID) || document.getElementById('popupToggle'));
  }

  /** Only products with gold-blocking need the main price locked against Globo addon totals. */
  function shouldLockProductPrice() {
    return !!document.querySelector('[id^="price-"][data-gb-lock-price]');
  }

  function getSelectedVariantFromDom() {
    const node = document.querySelector('variant-selects [data-selected-variant]');
    if (!node || !node.textContent) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function formatVariantMoney(cents) {
    if (typeof cents !== 'number' || isNaN(cents)) return null;
    const displayCents =
      window.VatDisplay && typeof window.VatDisplay.applyVatCents === 'function'
        ? window.VatDisplay.applyVatCents(cents)
        : cents;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      const format =
        (window.theme && window.theme.moneyFormat) ||
        (typeof Shopify.money_format !== 'undefined' ? Shopify.money_format : '{{amount}}');
      return Shopify.formatMoney(displayCents, format);
    }
    return null;
  }

  function captureBaseProductPriceFromDom() {
    const priceRoot = document.querySelector('[id^="price-"]');
    if (!priceRoot) return false;

    const snapshot = {};
    const saleAmount = priceRoot.querySelector('.price-item--sale .price-item__amount');
    if (saleAmount) snapshot.sale = saleAmount.textContent.trim();

    const regAmount = priceRoot.querySelector('.price__regular > .price-item--regular .price-item__amount');
    if (regAmount) snapshot.regular = regAmount.textContent.trim();

    const compareS = priceRoot.querySelector('.price__sale s.price-item--regular');
    if (compareS) snapshot.compareAt = compareS.textContent.trim();

    if (snapshot.sale || snapshot.regular) {
      basePriceSnapshot = snapshot;
      return true;
    }
    return false;
  }

  function captureBaseProductPriceFromDataAttrs() {
    const priceRoot = document.querySelector('[id^="price-"][data-gb-lock-price]');
    if (!priceRoot) return false;

    const cents = parseInt(priceRoot.getAttribute('data-gb-variant-price'), 10);
    if (isNaN(cents)) return false;

    const priceFormatted = formatVariantMoney(cents);
    if (!priceFormatted) return false;

    const compareCents = parseInt(priceRoot.getAttribute('data-gb-variant-compare-at'), 10);
    const onSale = !isNaN(compareCents) && compareCents > cents;
    const snapshot = {};

    if (onSale) {
      snapshot.sale = priceFormatted;
      const compareFormatted = formatVariantMoney(compareCents);
      if (compareFormatted) snapshot.compareAt = compareFormatted;
    } else {
      snapshot.regular = priceFormatted;
    }

    basePriceSnapshot = snapshot;
    return true;
  }

  function captureBaseProductPriceFromVariant(variant) {
    if (!variant && captureBaseProductPriceFromDataAttrs()) return true;

    variant = variant || getSelectedVariantFromDom();
    if (!variant || typeof variant.price !== 'number') return false;

    const priceFormatted = formatVariantMoney(variant.price);
    if (!priceFormatted) return false;

    const onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
    const snapshot = {};

    if (onSale) {
      snapshot.sale = priceFormatted;
      const compareFormatted = formatVariantMoney(variant.compare_at_price);
      if (compareFormatted) snapshot.compareAt = compareFormatted;
    } else {
      snapshot.regular = priceFormatted;
    }

    basePriceSnapshot = snapshot;
    return true;
  }

  function mainPriceNeedsRestore(priceRoot) {
    if (!basePriceSnapshot || !priceRoot) return false;

    if (basePriceSnapshot.sale) {
      const saleAmount = priceRoot.querySelector('.price-item--sale .price-item__amount');
      if (!saleAmount || saleAmount.textContent.trim() !== basePriceSnapshot.sale) return true;
    }

    if (basePriceSnapshot.regular) {
      const regAmount = priceRoot.querySelector('.price__regular > .price-item--regular .price-item__amount');
      if (!regAmount || regAmount.textContent.trim() !== basePriceSnapshot.regular) return true;
    }

    if (basePriceSnapshot.compareAt) {
      const compareS = priceRoot.querySelector('.price__sale s.price-item--regular');
      if (!compareS || compareS.textContent.trim() !== basePriceSnapshot.compareAt) return true;
    }

    return false;
  }

  function disconnectPriceObservers() {
    priceObservers.forEach(function (entry) {
      entry.observer.disconnect();
    });
  }

  function connectPriceObservers() {
    priceObservers.forEach(function (entry) {
      entry.observer.observe(entry.root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    });
  }

  function restoreBaseProductPrice() {
    if (!shouldLockProductPrice() || !basePriceSnapshot) return;

    const priceRoot = document.querySelector('[id^="price-"]');
    if (!priceRoot) return;

    if (basePriceSnapshot.sale) {
      const saleAmount = priceRoot.querySelector('.price-item--sale .price-item__amount');
      if (saleAmount && saleAmount.textContent.trim() !== basePriceSnapshot.sale) {
        saleAmount.textContent = basePriceSnapshot.sale;
      }
    }

    if (basePriceSnapshot.regular) {
      const regAmount = priceRoot.querySelector('.price__regular > .price-item--regular .price-item__amount');
      if (regAmount && regAmount.textContent.trim() !== basePriceSnapshot.regular) {
        regAmount.textContent = basePriceSnapshot.regular;
      }
    }

    if (basePriceSnapshot.compareAt) {
      const compareS = priceRoot.querySelector('.price__sale s.price-item--regular');
      if (compareS && compareS.textContent.trim() !== basePriceSnapshot.compareAt) {
        compareS.textContent = basePriceSnapshot.compareAt;
      }
    }
  }

  /** Keep VAT suffix without rebuilding the whole price node (avoids flicker). */
  function ensureProductPriceVatSuffix(root) {
    if (!document.body || !document.body.classList.contains('is-product-page')) return;

    const suffix = getVatSuffix();
    if (!suffix) return;
    const scope = root || document;
    const items = scope.querySelectorAll(
      '[id^="price-"] .price-item--sale, [id^="price-"] .price__regular > .price-item--regular'
    );

    items.forEach(function (el) {
      if (el.closest('s') || el.closest('.gpo-app, .gpo-container, [class*="gpo-"]')) return;

      let amountEl = el.querySelector('.price-item__amount');
      let vatEl = el.querySelector('.price-vat-suffix');

      if (!amountEl) {
        let amountText = '';
        if (el.classList.contains('price-item--sale') && basePriceSnapshot && basePriceSnapshot.sale) {
          amountText = basePriceSnapshot.sale;
        } else if (basePriceSnapshot && basePriceSnapshot.regular) {
          amountText = basePriceSnapshot.regular;
        } else {
          const text = (el.textContent || '').trim();
          amountText = text
            .replace(/\s*\(incl\.\s*VAT\)\s*$/i, '')
            .replace(/\s*\(inkl\.\s*MwSt\.\)\s*$/i, '')
            .replace(/\s*\(?excl\.\s*VAT\)?\s*$/i, '')
            .replace(/\s*\(?ekskl\.\s*Mwst\)?\s*$/i, '')
            .replace(/\s*\+VAT\s*$/i, '')
            .replace(/\s*\+Mwst\s*$/i, '')
            .trim();
        }
        amountEl = document.createElement('span');
        amountEl.className = 'price-item__amount';
        amountEl.textContent = amountText;
        el.textContent = '';
        el.appendChild(amountEl);
      }

      if (!vatEl) {
        vatEl = document.createElement('span');
        vatEl.className = 'price-vat-suffix';
        el.appendChild(vatEl);
      }

      if (vatEl.textContent.trim() !== suffix) vatEl.textContent = ' ' + suffix;
    });
  }

  function applyStableProductPrice() {
    if (!shouldLockProductPrice() || suppressPriceObserver) return;

    const priceRoot = document.querySelector('[id^="price-"][data-gb-lock-price], [id^="price-"]');
    if (!priceRoot || !basePriceSnapshot) return;

    const needsRestore = mainPriceNeedsRestore(priceRoot);
    if (!needsRestore) {
      ensureProductPriceVatSuffix(priceRoot);
      return;
    }

    suppressPriceObserver = true;
    disconnectPriceObservers();
    priceRoot.classList.add('price--gb-stabilizing');

    restoreBaseProductPrice();
    ensureProductPriceVatSuffix(priceRoot);

    requestAnimationFrame(function () {
      priceRoot.classList.remove('price--gb-stabilizing');
      suppressPriceObserver = false;
      connectPriceObservers();
    });
  }

  function scheduleStableProductPrice() {
    if (priceStabilizeScheduled) return;
    priceStabilizeScheduled = true;
    queueMicrotask(function () {
      priceStabilizeScheduled = false;
      applyStableProductPrice();
    });
  }

  function updateGbPriceDataFromVariant(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    const priceRoot = document.querySelector('[id^="price-"][data-gb-lock-price]');
    if (!priceRoot) return;

    priceRoot.setAttribute('data-gb-variant-price', String(variant.price));
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceRoot.setAttribute('data-gb-variant-compare-at', String(variant.compare_at_price));
    } else {
      priceRoot.removeAttribute('data-gb-variant-compare-at');
    }
  }

  function setupProductPriceVatPersistence() {
    if (!document.body.classList.contains('is-product-page') || !shouldLockProductPrice()) return;

    const priceRoot = document.querySelector('[id^="price-"][data-gb-lock-price]');
    if (priceRoot) priceRoot.classList.add('price--gb-stabilizing');

    captureBaseProductPriceFromVariant() || captureBaseProductPriceFromDom();
    applyStableProductPrice();

    if (priceRoot) {
      requestAnimationFrame(function () {
        priceRoot.classList.remove('price--gb-stabilizing');
      });
    }

    setTimeout(function () {
      captureBaseProductPriceFromVariant();
      applyStableProductPrice();
    }, 400);

    document.querySelectorAll('[id^="price-"]').forEach(function (priceRoot) {
      const observer = new MutationObserver(function () {
        if (suppressPriceObserver) return;
        scheduleStableProductPrice();
      });
      priceObservers.push({ root: priceRoot, observer: observer });
      observer.observe(priceRoot, { childList: true, subtree: true, characterData: true });
    });

    const formBlock = document.getElementById(FORM_BLOCK_ID);
    if (formBlock) {
      formBlock.addEventListener('change', scheduleStableProductPrice);
      formBlock.addEventListener('input', scheduleStableProductPrice);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const variant = event && event.data ? event.data.variant : null;
        if (!variant) return;

        suppressPriceObserver = true;
        disconnectPriceObservers();
        updateGbPriceDataFromVariant(variant);
        captureBaseProductPriceFromVariant(variant);

        requestAnimationFrame(function () {
          suppressPriceObserver = false;
          connectPriceObservers();
          applyStableProductPrice();
        });
      });
    }
  }

  function resetGloboAddonTotal() {
    const el = document.querySelector('.gpo-total .money');
    if (!el) return;
    el.textContent = formatGbMoney(0);
  }

  function gbStrings() {
    return isDeMarket() ? STRINGS_DE : STRINGS_EN;
  }

  /** DE: "10,00 €" — GB: "£10.00" */
  function formatGbMoney(amount) {
    const n = Number(amount);
    if (isNaN(n)) return isDeMarket() ? '0,00 €' : '£0.00';
    if (isDeMarket()) return n.toFixed(2).replace('.', ',') + ' €';
    return '£' + n.toFixed(2);
  }

  function formatGbUnitRate(amount) {
    if (isDeMarket()) return formatGbMoney(amount);
    return '£' + Number(amount).toFixed(2);
  }

  function convertPoundTextToEuro(text) {
    if (!text || text.indexOf('£') === -1) return text;
    return text.replace(/£\s*([\d.,]+)/g, function (_, num) {
      const cleaned = String(num).replace(/,/g, '');
      const n = parseFloat(cleaned);
      if (isNaN(n)) return num + ' €';
      return n.toFixed(2).replace('.', ',') + ' €';
    });
  }

  function replaceCurrencyInElement(el) {
    if (!el || !el.childNodes) return;
    el.childNodes.forEach(function (node) {
      if (node.nodeType === 3) {
        const next = convertPoundTextToEuro(node.textContent);
        if (next !== node.textContent) node.textContent = next;
      } else if (node.nodeType === 1 && node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE') {
        replaceCurrencyInElement(node);
      }
    });
  }

  function localizeCurrencyInGlobo(root) {
    if (!isDeMarket() || !root) return;
    root.querySelectorAll(
      '.gpo-label, .gpo-swatches, .gpo-tinymce, .gpo-dropzone, .gpo-heading, .gpo-element, .gpo-group, .gpo-field, .gpo-total'
    ).forEach(replaceCurrencyInElement);
  }

  function localizeDeCartCurrency(root) {
    if (!isDeMarket()) return;
    const scope = root || document;
    scope.querySelectorAll(
      'cart-drawer, #CartDrawer, #main-cart-items, .cart-drawer, .cart__footer-wrapper, .order_summary, cart-notification, .cart-item'
    ).forEach(replaceCurrencyInElement);
    const summary = document.getElementById('gb-price-summary');
    if (summary) replaceCurrencyInElement(summary);
    const popupSubtotal = document.getElementById('gb-popup-subtotal');
    if (popupSubtotal) replaceCurrencyInElement(popupSubtotal);
  }

  function setupDeCartCurrencyDisplay() {
    if (!isDeMarket()) return;
    function run() { localizeDeCartCurrency(document); }
    run();
    [100, 500, 1500, 3000].forEach(function (delay) {
      setTimeout(run, delay);
    });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(run, 100);
        setTimeout(run, 500);
      });
    }
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver(function () {
        localizeDeCartCurrency(cartDrawer);
      });
      observer.observe(cartDrawer, { childList: true, subtree: true, characterData: true });
    }
  }

  function normalizeGbText(text) {
    return (text || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function isApplyControlText(text) {
    const t = normalizeGbText(text);
    if (!t) return false;
    if (t === normalizeGbText(STRINGS_EN.applyButton)) return true;
    if (t === normalizeGbText(STRINGS_DE.applyButton)) return true;
    if (t === normalizeGbText('Apply Gold-Blocking')) return true;
    for (let i = 0; i < GLOBO_DE_NATIVE_APPLY.length; i++) {
      if (t === normalizeGbText(GLOBO_DE_NATIVE_APPLY[i])) return true;
    }
    return t.indexOf('goldblock') !== -1 && t.indexOf('anwenden') !== -1;
  }

  function isApplyRadioValue(value) {
    return isApplyControlText(value);
  }

  function isCancelControlText(text) {
    const t = normalizeGbText(text);
    if (!t) return false;
    if (t === 'cancle' || t === normalizeGbText(STRINGS_EN.cancelButton)) return true;
    if (t === normalizeGbText(STRINGS_DE.cancelButton)) return true;
    for (let i = 0; i < GLOBO_DE_NATIVE_CANCEL.length; i++) {
      if (t === normalizeGbText(GLOBO_DE_NATIVE_CANCEL[i])) return true;
    }
    return t === 'stornieren';
  }

  function isCancelRadioValue(value) {
    return isCancelControlText(value);
  }

  function replaceMappedText(text) {
    if (!isDeMarket() || !text) return text;
    let out = text;
    GLOBO_TEXT_MAP_DE.forEach(function (pair) {
      if (out.indexOf(pair[0]) !== -1) {
        out = out.split(pair[0]).join(pair[1]);
      }
    });
    return out;
  }

  function setElementText(el, text) {
    if (!el || text == null) return;
    el.textContent = text;
  }

  /**
   * Innermost elements holding `pattern`. Anything wrapping a form control is skipped so the
   * checkbox itself is never overwritten, and an ancestor is dropped when a child also matches,
   * so the label and its heading are each rewritten once.
   */
  function findCopyHolders(scope, pattern) {
    if (!scope) return [];
    const matches = [];
    scope.querySelectorAll('label, span, div, p, strong, em').forEach(function (el) {
      if (el.querySelector('input, select, textarea')) return;
      const text = (el.textContent || '').trim();
      if (text && pattern.test(text)) matches.push(el);
    });
    return matches.filter(function (el) {
      return !matches.some(function (other) { return other !== el && el.contains(other); });
    });
  }

  function setCopy(el, copy) {
    if (el && el.innerHTML.trim() !== copy) el.innerHTML = copy;
  }

  /** Label wraps the checkbox: blank its own text nodes and carry the copy in a span instead. */
  function setWrappedLabelCopy(label, copy) {
    const existing = label.querySelector('.gb-die-copy');
    if (existing) {
      setCopy(existing, copy);
      return;
    }
    Array.prototype.slice.call(label.childNodes).forEach(function (node) {
      if (node.nodeType === 3) node.textContent = '';
    });
    const span = document.createElement('span');
    span.className = 'gb-die-copy';
    span.innerHTML = copy;
    label.appendChild(span);
  }

  /** Globo owns this label, so restate it after every re-render to match how the fee is charged. */
  function applyDieOnFileCopy(root) {
    const scope = root || document.getElementById(FORM_BLOCK_ID) || document;
    const inputs = scope.querySelectorAll(
      'input[type="checkbox"][name="gb_die_on_file"], input[type="checkbox"][data-field-name="gb_die_on_file"]'
    );
    if (!inputs.length) return;

    const copy = dieOnFileCopy();

    inputs.forEach(function (input) {
      const group = input.closest('.gpo-element, .gpo-group, .gpo-field') || scope;

      let holders = findCopyHolders(group, DIE_ON_FILE_COPY_PATTERN);
      if (!holders.length) holders = findCopyHolders(scope, DIE_ON_FILE_COPY_PATTERN);

      if (holders.length) {
        holders.forEach(function (holder) { setCopy(holder, copy); });
        return;
      }

      const wrapping = input.closest('label');
      if (wrapping) {
        setWrappedLabelCopy(wrapping, copy);
        return;
      }

      setCopy(group.querySelector('.gpo-label .label-content'), copy);
    });
  }

  let globoTranslateTimer = null;

  function scheduleTranslateGloboPopup(root) {
    if (!root) return;
    clearTimeout(globoTranslateTimer);
    globoTranslateTimer = setTimeout(function () {
      translateGloboPopup(root);
    }, 50);
  }

  function watchGloboTranslations() {
    const formBlock = document.getElementById(FORM_BLOCK_ID);
    if (!formBlock || formBlock.dataset.gbTranslateWatch) return;
    formBlock.dataset.gbTranslateWatch = '1';
    scheduleTranslateGloboPopup(formBlock);
    const observer = new MutationObserver(function () {
      scheduleTranslateGloboPopup(formBlock);
    });
    observer.observe(formBlock, { childList: true, subtree: true, characterData: true });
  }

  function translateGloboPopup(root) {
    if (!root) return;

    applyDieOnFileCopy(root);

    if (!isDeMarket()) return;

    Object.keys(GLOBO_FIELD_LABELS_DE).forEach(function (fieldName) {
      const labelDe = GLOBO_FIELD_LABELS_DE[fieldName];
      root.querySelectorAll(
        '[data-field-name="' + fieldName + '"], [name="' + fieldName + '"]'
      ).forEach(function (field) {
        const group = field.closest('.gpo-element, .gpo-group, .gpo-field');
        if (!group) return;
        const labelContent = group.querySelector('.gpo-label .label-content, .gpo-label span.label-content');
        if (labelContent) setElementText(labelContent, labelDe);
      });
    });

    root.querySelectorAll('.gpo-label .label-content, .gpo-label span.label-content').forEach(function (el) {
      const next = replaceMappedText(el.textContent.trim());
      if (next !== el.textContent.trim()) setElementText(el, next);
    });

    root.querySelectorAll('.gpo-swatches.buttons label, .gpo-swatches.buttons input + label').forEach(function (el) {
      const next = replaceMappedText(el.textContent.trim());
      if (next !== el.textContent.trim()) setElementText(el, next);
    });

    root.querySelectorAll('.gpo-tinymce p, .gpo-tinymce h1, .gpo-tinymce h2, .gpo-tinymce h3, .gpo-tinymce h4, .gpo-tinymce li').forEach(function (el) {
      const next = replaceMappedText(el.textContent.trim());
      if (next !== el.textContent.trim()) setElementText(el, next);
    });

    root.querySelectorAll('.gpo-dropzone__caption, .gpo-dropzone__action').forEach(function (el) {
      const next = replaceMappedText(el.textContent.trim());
      if (next !== el.textContent.trim()) setElementText(el, next);
    });

    root.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function (el) {
      if (el.placeholder) el.placeholder = replaceMappedText(el.placeholder);
    });

    root.querySelectorAll('.gpo-heading h2, .gpo-heading h3').forEach(function (el) {
      const next = replaceMappedText(el.textContent.trim());
      if (next !== el.textContent.trim()) setElementText(el, next);
    });

    localizeCurrencyInGlobo(root);
    ensurePopupSubtotal();
  }

  function isApplySwatch(el) {
    if (!el) return false;
    const input = el.querySelector('input[type="radio"], input');
    if (input && isApplyRadioValue(input.value)) return true;
    const label = el.querySelector('label');
    return !!(label && isApplyControlText(label.textContent));
  }

  function isCancelSwatch(el) {
    if (!el) return false;
    const input = el.querySelector('input[type="radio"], input');
    if (input && isCancelRadioValue(input.value)) return true;
    const label = el.querySelector('label');
    return !!(label && isCancelControlText(label.textContent));
  }

  let applyHandling = false;

  function handleApplyGoldBlocking() {
    if (applyHandling) return;
    applyHandling = true;
    setTimeout(function () { applyHandling = false; }, 400);

    const data = calculate();
    if (data.isActive) showPriceSummary(data);
    else alert(gbStrings().selectOption);
  }

  // ─── Helpers ────────────────────────────────────────────────
  function getProductQuantityInput() {
    const productInfo = document.querySelector('product-info');
    if (productInfo) {
      const el = productInfo.querySelector('.quantity__input, input[name="quantity"]');
      if (el) return el;
    }
    const form = document.querySelector('.product-form, form[action*="/cart/add"]');
    if (form) {
      const el = form.querySelector('input[name="quantity"], .quantity__input');
      if (el) return el;
    }
    return null;
  }

  function getQty() {
    const el = getProductQuantityInput();
    if (el) {
      const v = parseInt(el.value, 10);
      return isNaN(v) || v < 1 ? 1 : v;
    }
    return 1;
  }

  function getVal(name) {
    const el = document.querySelector('input[name="' + name + '"], textarea[name="' + name + '"]');
    return el ? el.value.trim() : '';
  }

  function isChecked(name) {
    const els = document.querySelectorAll(
      'input[type="checkbox"][name="' + name + '"], input[type="checkbox"][data-field-name="' + name + '"]'
    );
    for (const el of els) { if (el.checked) return true; }
    return false;
  }

  // ─── Popup live subtotal (above intro copy, below heading) ───
  const POPUP_INTRO_EN = /folders you have selected|automatically updates|Subtotal for Goldblocking/i;
  const POPUP_INTRO_DE = /Zwischensumme für Goldblocking|Anzahl der Ordner|automatisch entsprechend/i;

  /** Innermost node whose text is the "subtotal updates with folder quantity" note. */
  function findPopupIntro(formBlock, pattern) {
    let best = null;
    formBlock.querySelectorAll('p, li, .gpo-tinymce, div, span').forEach(function (el) {
      if (el.closest('#gb-popup-subtotal')) return;
      const text = el.textContent || '';
      if (!pattern.test(text)) return;
      if (!best || text.length < best.textContent.length) best = el;
    });
    return best;
  }

  function getPopupSubtotalAnchor() {
    const formBlock = document.getElementById(FORM_BLOCK_ID);
    if (!formBlock) return null;

    const intro = findPopupIntro(formBlock, isDeMarket() ? POPUP_INTRO_DE : POPUP_INTRO_EN)
      || findPopupIntro(formBlock, isDeMarket() ? POPUP_INTRO_EN : POPUP_INTRO_DE);
    if (intro) return intro.closest('.gpo-element') || intro;

    const firstTinymce = formBlock.querySelector('.gpo-tinymce');
    if (firstTinymce) {
      return firstTinymce.closest('.gpo-element, .gpo-group') || firstTinymce;
    }

    const applyBtn = formBlock.querySelector('input[name="buttons-1"]');
    if (applyBtn) {
      return applyBtn.closest('.gpo-element') || applyBtn.closest('.gpo-group') || applyBtn.parentElement;
    }

    const applySwatch = formBlock.querySelector('.gpo-swatches.buttons.gpo-ov-item');
    if (applySwatch) {
      const wrapper = applySwatch.closest('.gpo-ov-wrapper, .gpo-element, .gpo-group');
      if (wrapper) return wrapper;
    }

    return formBlock.querySelector('[data-element-id="radio-3"]');
  }

  function ensurePopupSubtotal() {
    const anchor = getPopupSubtotalAnchor();
    if (!anchor || !anchor.parentNode) return null;

    let el = document.getElementById('gb-popup-subtotal');
    if (!el) {
      el = document.createElement('div');
      el.id = 'gb-popup-subtotal';
      el.className = 'gb-popup-subtotal';
      el.innerHTML =
        '<span class="gb-popup-subtotal__label"></span>' +
        '<span class="gb-popup-subtotal__amount"></span>';
    }

    const labelEl = el.querySelector('.gb-popup-subtotal__label');
    const label = gbStrings().popupSubtotal;
    if (labelEl && labelEl.textContent !== label) labelEl.textContent = label;

    if (el.nextElementSibling !== anchor) {
      anchor.parentNode.insertBefore(el, anchor);
    }

    return el;
  }

  function updatePopupSubtotal(data) {
    const el = ensurePopupSubtotal();
    if (!el) return;

    const amountEl = el.querySelector('.gb-popup-subtotal__amount');
    if (!amountEl) return;

    const d = data || { raw: 0, subtotal: 0, isActive: false };
    amountEl.textContent = formatGbMoney(d.isActive ? d.subtotal : 0);
  }

  // ─── Calculate ──────────────────────────────────────────────
  function calculate() {
    const qty = getQty();
    const lines  = [getVal('gb_line_1'), getVal('gb_line_2'), getVal('gb_line_3')]
      .filter(v => v.length > 0).length;

    const price  = gbPrices();
    const textCh = lines * price.textLine;
    const instCh = isChecked('gb_instrument_charge') ? price.instrument : 0;

    // Ticked = artwork already on file: waive the one-off die (UK £105 / DE €115)
    // and still charge the impression (UK £3.00 / DE €2.50) per folder. A logo
    // upload charges that same impression once — the two selections must not stack.
    const dieOnFile = isChecked('gb_die_on_file');
    const logoCh = (isChecked('gb_logo_charge') || dieOnFile) ? price.logo : 0;
    const dieCh = logoCh > 0 && !dieOnFile ? price.newDie : 0;

    // The £10 minimum covers text and instrument only. Folding the £3 impression
    // into it turned a new die into £10 + £105 = £115 instead of £105 + £3.
    const optionRaw        = textCh + instCh;
    const optionCalculated = optionRaw > 0 ? roundMoney(optionRaw * qty) : 0;
    const optionTotal      = optionRaw > 0 ? getGoldBlockingTotal(optionRaw, qty) : 0;
    const logoTotal        = roundMoney(logoCh * qty);
    const raw              = optionRaw + logoCh;
    const calculated       = roundMoney(optionCalculated + logoTotal);
    const total            = roundMoney(optionTotal + logoTotal + dieCh);
    const isActive         = total > 0;
    const subtotal         = total;

    console.log('[GB] per folder:', raw, 'x', qty, '| impression:', logoTotal, '| one-off die:', dieCh, '| total:', total);

    const result = {
      total, subtotal, unitSubtotal: raw, calculated, perItemTotal: optionTotal,
      raw, optionRaw, optionCalculated, logoTotal, isActive,
      lines, instCh, logoCh, dieCh, dieOnFile, qty: qty
    };
    updatePopupSubtotal(result);
    return result;
  }

  function goldBlockingCartPropertyValue() {
    const d = calculate();
    if (!d.isActive) return null;
    return formatGbMoney(d.total);
  }

  function gbCartPropertyFormName() {
    return 'properties[' + GB_CART_TOTAL_PROPERTY + ']';
  }

  function applyGoldBlockingTotalToFormData(fd) {
    const v = goldBlockingCartPropertyValue();
    if (v === null) {
      fd.delete(gbCartPropertyFormName());
    } else {
      fd.set(gbCartPropertyFormName(), v);
    }
  }

  function applyGoldBlockingTotalToUrlParams(params) {
    const v = goldBlockingCartPropertyValue();
    if (v === null) {
      params.delete(gbCartPropertyFormName());
    } else {
      params.set(gbCartPropertyFormName(), v);
    }
  }

  // ─── File Restored Indicator ────────────────────────────────
  function showFileRestoredIndicator(fieldName, fileName) {
    const str = gbStrings();
    const oldId = 'gb-file-indicator-' + fieldName;
    const old = document.getElementById(oldId);
    if (old) old.remove();

    const fileInput = document.querySelector(
      'input[type="file"][name="' + fieldName + '"], input[type="file"][data-field-name="' + fieldName + '"]'
    );
    if (!fileInput) return;

    const indicator = document.createElement('div');
    indicator.id = oldId;
    indicator.style.cssText = 'margin-top:6px;padding:6px 10px;background:#fff8e1;border:1px solid #f0c040;border-radius:4px;font-size:12px;color:#7a6000;display:flex;align-items:center;gap:6px;';
    indicator.innerHTML =
      '📎 ' + str.fileRestored + ' <strong>' + fileName + '</strong> &nbsp;<span style="color:#888;font-size:11px;">' + str.reupload + '</span>';
    fileInput.parentNode.insertBefore(indicator, fileInput.nextSibling);
  }

  function removeFileIndicators() {
    ['gb-file-indicator-gb_instrument_file', 'gb-file-indicator-gb_logo_file'].forEach(function(id) {
      const el = document.getElementById(id);
      if (el) el.remove();
    });
  }

  // ─── Price Summary ──────────────────────────────────────────
  function gbRowHtml(label, value, extraClass) {
    return '<div class="gb-row' + (extraClass ? ' ' + extraClass : '') + '">' +
      '<span>' + label + '</span><span>' + value + '</span></div>';
  }

  function buildPriceSummaryHtml(d) {
    const str = gbStrings();
    const price = gbPrices();
    const optionRaw = typeof d.optionRaw === 'number' ? d.optionRaw : 0;
    const minApplies = minChargeApplies(optionRaw, d.qty);
    let rows = '';

    if (minApplies) {
      rows += gbRowHtml(str.minChargeRow, formatGbMoney(price.minimum));
    } else {
      if (d.lines > 0) {
        const lineSub = d.lines * price.textLine;
        rows += gbRowHtml(
          str.textLines + ' (' + d.lines + ' x ' + formatGbUnitRate(price.textLine) + ')',
          formatGbMoney(lineSub)
        );
      }
      if (d.instCh > 0) rows += gbRowHtml(str.instrument, formatGbMoney(d.instCh));

      if (d.qty > 1 && optionRaw > 0) {
        const optionCalculated = typeof d.optionCalculated === 'number' ? d.optionCalculated : roundMoney(optionRaw * d.qty);
        rows += gbRowHtml(
          str.perItem,
          formatGbMoney(optionRaw) + ' × ' + d.qty + ' = ' + formatGbMoney(optionCalculated),
          'gb-row--per-item'
        );
      }
    }

    if (d.logoCh > 0) {
      const logoTotal = typeof d.logoTotal === 'number' ? d.logoTotal : roundMoney(d.logoCh * d.qty);
      const logoLabel = d.qty > 1
        ? str.logo + ' (' + formatGbUnitRate(d.logoCh) + ' × ' + d.qty + ')'
        : str.logo;
      rows += gbRowHtml(logoLabel, formatGbMoney(logoTotal));
    }

    // Charged once for the whole order, so it sits outside the per-folder subtotal above.
    if (d.dieCh > 0) {
      rows += gbRowHtml(str.newDie + ' ' + str.oneOff, formatGbMoney(d.dieCh), 'gb-row--one-off');
    }

    const minLine = minApplies
      ? '<div class="gb-min">' + str.minChargeNote.replace('{raw}', formatGbMoney(typeof d.optionCalculated === 'number' ? d.optionCalculated : 0)) + '</div>'
      : '';

    return '<div class="gb-head">' + str.applied + '</div>' +
      rows +
      minLine +
      '<div class="gb-total"><span>' + str.total + '</span><span>' + formatGbMoney(d.total) + '</span></div>';
  }

  function showPriceSummary(d) {
    removePriceSummary();

    const div = document.createElement('div');
    div.id = 'gb-price-summary';
    div.innerHTML = buildPriceSummaryHtml(d);

    const target = document.querySelector('.product-form__buttons, form[action="/cart/add"] button[type="submit"]');
    if (target) {
      const parent = target.closest('.product-form__buttons') || target.parentNode;
      parent.insertAdjacentElement('afterend', div);
    }

    closeModal();

    const toggle = document.getElementById('popupToggle');
    if (toggle) toggle.checked = true;

    localizeDeCartCurrency(document);
    applyStableProductPrice();
    scheduleProcessGbAddonInput();
  }

  function removePriceSummary() {
    const el = document.getElementById('gb-price-summary');
    if (el) el.remove();
  }

  // ─── Reset ──────────────────────────────────────────────────
  function resetAllFields() {
    ['gb_line_1', 'gb_line_2', 'gb_line_3'].forEach(function (name) {
      const el = document.querySelector('input[name="' + name + '"], textarea[name="' + name + '"]');
      if (el) { el.value = ''; el.dispatchEvent(new Event('input')); }
    });
    ['gb_instrument_file', 'gb_logo_file'].forEach(function (name) {
      const fi = document.querySelector('input[type="file"][name="' + name + '"], input[type="file"][data-field-name="' + name + '"]');
      if (fi) fi.value = '';
    });
    ['gb_instrument_charge', 'gb_logo_charge', 'gb_die_on_file'].forEach(function (name) {
      document.querySelectorAll('input[type="checkbox"][name="' + name + '"], input[type="checkbox"][data-field-name="' + name + '"]').forEach(function (el) {
        if (el.checked) { el.checked = false; el.dispatchEvent(new Event('change')); }
      });
    });
    removePriceSummary();
    removeFileIndicators();

    document.querySelectorAll('form[action*="cart/add"]').forEach(function (form) {
      Array.prototype.forEach.call(form.querySelectorAll('input'), function (inp) {
        if (inp.name === gbCartPropertyFormName()) inp.remove();
      });
    });

    const toggle = document.getElementById('popupToggle');
    if (toggle) toggle.checked = false;

    cartSyncDone = false;
    closeModal();
    applyStableProductPrice();
    updatePopupSubtotal({ raw: 0, isActive: false });
  }

  // ─── Styles ─────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('gb-styles')) return;
    const s = document.createElement('style');
    s.id = 'gb-styles';
    s.textContent = [
      '#gb-price-summary{margin-top:12px;padding:14px 16px;background:#f0f7f0;border:1px solid #b8d4b8;border-radius:6px;font-size:14px;line-height:1.7}',
      '.gb-head{font-weight:700;font-size:15px;color:#2d6a2d;margin-bottom:8px}',
      '.gb-row{display:flex;justify-content:space-between;color:#444;padding:2px 0;border-bottom:1px dashed #ddd}',
      '.gb-row--one-off{margin-top:4px;padding-top:6px;border-top:1px solid #cfe0cf;border-bottom:none;font-weight:600;color:#2d6a2d}',
      '.gb-min{font-size:12px;color:#888;margin:4px 0}',
      '.gb-total{display:flex;justify-content:space-between;font-weight:700;font-size:15px;color:#2d6a2d;margin-top:8px;padding-top:8px;border-top:2px solid #b8d4b8}',
      '[id^="price-"].price--gb-stabilizing .price__container{visibility:hidden}'
    ].join('');
    document.head.appendChild(s);
  }

  function injectModalStyles() {
    if (document.getElementById('gb-modal-styles')) return;
    const s = document.createElement('style');
    s.id = 'gb-modal-styles';
    s.textContent = `
      /*
        The overlay scrolls, not just the box. A flex child centred with align-items that
        outgrows its container is clipped at BOTH ends with no way to reach them, so the box
        is centred with auto margins instead and the overlay takes the overflow. German
        labels run longer than English, which is why the DE popup hit this first.
      */
      #gb-modal-overlay {
        position: fixed; inset: 0; background: rgba(0,0,0,0.5);
        z-index: 99998; display: flex; justify-content: center;
        box-sizing: border-box; padding: 16px;
        overflow-y: auto; overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
      }
      #gb-modal-box {
        background: #fff; border-radius: 10px; width: 100%; max-width: 620px;
        box-sizing: border-box; margin: auto;
        /* vh counts the area behind a phone's address bar, so the last rows of a 90vh box
           sit under the browser chrome. dvh measures what is actually visible; the vh line
           above it is the fallback for browsers without dvh. */
        max-height: calc(100vh - 32px);
        max-height: calc(100dvh - 32px);
        max-height: var(--gb-modal-max-h, calc(100dvh - 32px));
        overflow-y: auto; overscroll-behavior: contain;
        -webkit-overflow-scrolling: touch;
        position: relative; z-index: 99999;
        padding: 24px 24px 40px; box-shadow: 0 8px 32px rgba(0,0,0,0.25);
      }
      #gb-modal-close {
        position: sticky; top: 0; margin-left: auto; display: block;
        background: #333; color: #fff;
        border: none; border-radius: 50%; width: 30px; height: 30px;
        font-size: 18px; cursor: pointer; line-height: 30px; text-align: center; z-index: 100000;
      }
      #gb-modal-close:hover { background: #000; }
    `;
    document.head.appendChild(s);
  }

  // ─── Cart line helpers ───────────────────────────────────────
  function findCartLineForCurrentProduct(cart) {
    if (!cart.items || cart.items.length === 0) return null;

    const pathMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
    const currentHandle = pathMatch ? pathMatch[1] : null;
    let item = null;

    if (currentHandle) {
      item = cart.items.find(function (i) { return i.handle === currentHandle; });
    }
    if (!item) {
      const variantInput = document.querySelector('input[name="id"]');
      const currentVariant = variantInput ? variantInput.value : null;
      if (currentVariant) {
        item = cart.items.find(function (i) { return String(i.variant_id) === String(currentVariant); });
      }
    }
    return item;
  }

  function lineHasGoldBlocking(props) {
    if (!props) return false;
    return !!(
      props['gb_line_1'] || props['gb_line_2'] || props['gb_line_3'] ||
      props['gb_instrument_charge'] || props['gb_logo_charge'] || props['gb_die_on_file'] ||
      props[GB_CART_TOTAL_PROPERTY]
    );
  }

  /** Clear UI so a new cart line can use different gold-blocking options. */
  function clearGoldBlockingForNewLine() {
    document.querySelectorAll('input[name="buttons-1"]').forEach(function (radio) {
      if (radio.checked && isApplyRadioValue(radio.value)) {
        radio.checked = false;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    resetAllFields();
    cartSyncDone = true;
  }

  /** Delegated handlers so Apply/Cancel work after Globo re-renders and on DE-localized values/labels. */
  function setupDelegatedSwatchListeners() {
    if (document.documentElement.dataset.gbSwatchDelegation) return;
    document.documentElement.dataset.gbSwatchDelegation = '1';

    document.addEventListener('click', function (e) {
      const swatch = e.target.closest('.gpo-swatches.buttons.gpo-ov-item');
      if (!swatch) return;

      if (isApplySwatch(swatch)) {
        setTimeout(function () {
          const input = swatch.querySelector('input[type="radio"], input');
          if (input && !input.checked) input.checked = true;
          handleApplyGoldBlocking();
        }, 0);
        return;
      }

      if (isCancelSwatch(swatch)) {
        e.preventDefault();
        resetAllFields();
      }
    }, true);
  }

  // If this product is already in the cart with gold-blocking, do not restore selections.
  function syncFromCart() {
    if (cartSyncDone) return;
    cartSyncDone = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const item = findCartLineForCurrentProduct(cart);
        if (!item || !lineHasGoldBlocking(item.properties)) return;
        if (document.getElementById('gb-modal-overlay')) return;

        console.log('[GB] Product already in cart with gold-blocking — clearing form for a new configuration');
        clearGoldBlockingForNewLine();
      })
      .catch(function (err) { console.log('[GB] Cart check failed:', err); });
  }

  function setupCartAddReset() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      if (!document.getElementById('popupToggle') && !document.getElementById(FORM_BLOCK_ID)) return;

      setTimeout(function () {
        console.log('[GB] Added to cart — resetting gold-blocking for next configuration');
        clearGoldBlockingForNewLine();
      }, 150);
    });
  }

  // ─── Attach Listeners ────────────────────────────────────────
  function onProductQtyChange() {
    if (!hasGoldBlockingProduct()) return;
    if (!document.getElementById('gb-price-summary')) {
      calculate();
      return;
    }
    refreshPriceSummary();
    processGbAddonInput();
  }

  function setupQuantityWatch() {
    if (!document.body.classList.contains('is-product-page') || !hasGoldBlockingProduct()) return;
    if (document.body.dataset.gbQtyWatch) return;
    document.body.dataset.gbQtyWatch = '1';

    function onQtyEvent(e) {
      const el = e.target;
      if (!el || !el.matches('.quantity__input, input[name="quantity"]')) return;
      if (!el.closest('product-info') && !el.closest('.product-form')) return;
      onProductQtyChange();
    }

    document.addEventListener('change', onQtyEvent, true);
    document.addEventListener('input', onQtyEvent, true);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.quantityUpdate, onProductQtyChange);
    }
  }

  function attachListeners() {
    if (listenersAttached) return false;
    let found = 0;

    const checkboxWrapper = document.querySelector('[data-element-id="checkbox-2"]');
    if (checkboxWrapper) checkboxWrapper.style.setProperty('display', 'none', 'important');
    const logoCheckboxWrapper = document.querySelector('[data-element-id="checkbox-3"]');
    if (logoCheckboxWrapper) logoCheckboxWrapper.style.setProperty('display', 'none', 'important');

    // ─── Helper: file input ki actual state check karo ──────────
    // Globo delete karne pe input.files clear nahi karta — data-value ya dropzone preview check karo
    function fileHasValue(inputEl) {
      if (!inputEl) return false;
      // 1. Standard files API
      if (inputEl.files && inputEl.files.length > 0) return true;
      // 2. Globo data-value attribute (upload ke baad set hota hai)
      if (inputEl.getAttribute('data-value') && inputEl.getAttribute('data-value').trim() !== '') return true;
      // 3. Dropzone preview thumbnail ya filename text check karo
      const dropzone = inputEl.closest('.gpo-dropzone');
      if (dropzone) {
        const preview = dropzone.querySelector('.gpo-dropzone__preview, .gpo-thumbnail, [class*="preview"], [class*="thumbnail"]');
        if (preview) return true;
        const caption = dropzone.querySelector('.gpo-dropzone__caption');
        // Empty dropzone still shows default "drop file" / "Datei ablegen" copy
        if (caption && caption.textContent) {
          const cap = caption.textContent.toLowerCase();
          if (cap.indexOf('drop file') === -1 && cap.indexOf('datei ablegen') === -1) return true;
        }
      }
      return false;
    }

    // ─── File watch karo via MutationObserver + change event ─────
    function watchFileInput(fileInputEl, checkboxSel) {
      if (!fileInputEl) return;

      function syncCheckbox() {
        const checkbox = document.querySelector(checkboxSel);
        if (!checkbox) return;
        const hasFile = fileHasValue(fileInputEl);
        if (hasFile && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (!hasFile && checkbox.checked) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // Standard change event (file select pe)
      fileInputEl.addEventListener('change', syncCheckbox);

      // MutationObserver — Globo jab data-value change kare ya dropzone DOM change kare
      const dropzone = fileInputEl.closest('.gpo-dropzone') || fileInputEl.parentNode;
      if (dropzone) {
        const observer = new MutationObserver(function() {
          setTimeout(syncCheckbox, 100); // thoda wait karo Globo ke DOM update ke baad
        });
        observer.observe(dropzone, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-value', 'class'] });
      }

      // Attribute observer on input itself
      const attrObserver = new MutationObserver(function() {
        setTimeout(syncCheckbox, 100);
      });
      attrObserver.observe(fileInputEl, { attributes: true, attributeFilter: ['data-value'] });
    }

    const fileInput = document.querySelector('input[type="file"][name="gb_instrument_file"], input[type="file"][data-field-name="gb_instrument_file"]');
    if (fileInput) {
      watchFileInput(
        fileInput,
        'input[type="checkbox"][name="gb_instrument_charge"], input[type="checkbox"][data-field-name="gb_instrument_charge"]'
      );
      found++;
    }

    const logoFileInput = document.querySelector('input[type="file"][name="gb_logo_file"], input[type="file"][data-field-name="gb_logo_file"]');
    if (logoFileInput) {
      watchFileInput(
        logoFileInput,
        'input[type="checkbox"][name="gb_logo_charge"], input[type="checkbox"][data-field-name="gb_logo_charge"]'
      );
      found++;
    }

    ['gb_line_1', 'gb_line_2', 'gb_line_3'].forEach(function (name) {
      const el = document.querySelector('input[name="' + name + '"], textarea[name="' + name + '"]');
      if (el) { el.addEventListener('input', calculate); found++; }
    });

    ['gb_instrument_charge', 'gb_logo_charge', 'gb_die_on_file'].forEach(function (name) {
      document.querySelectorAll('input[type="checkbox"][name="' + name + '"], input[type="checkbox"][data-field-name="' + name + '"]').forEach(function (el) {
        el.addEventListener('change', calculate);
        found++;
      });
    });

    const qtyEl = getProductQuantityInput();
    if (qtyEl) {
      qtyEl.addEventListener('change', onProductQtyChange);
      qtyEl.addEventListener('input', onProductQtyChange);
    }

    document.querySelectorAll('input[name="buttons-1"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (isApplyRadioValue(radio.value) && radio.checked) {
          if (suppressApplyFromRadio) return;
          handleApplyGoldBlocking();
        }
        if (isCancelRadioValue(radio.value) && radio.checked) {
          resetAllFields();
        }
      });
      found++;
    });

    document.querySelectorAll('button').forEach(function (btn) {
      const txt = btn.textContent.trim();
      if (isApplyControlText(txt)) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          const data = calculate();
          if (data.isActive) showPriceSummary(data);
          else alert(gbStrings().selectOption);
        });
        found++;
      }
      if (isCancelControlText(txt)) {
        btn.addEventListener('click', function (e) { e.preventDefault(); resetAllFields(); });
        found++;
      }
    });

    const hasApplyControl = document.querySelectorAll('input[name="buttons-1"]').length > 0;

    if (found > 0 && hasApplyControl) {
      const formBlock = document.getElementById(FORM_BLOCK_ID);
      if (formBlock) {
        scheduleTranslateGloboPopup(formBlock);
        ensurePopupSubtotal();
      }
      listenersAttached = true;
      calculate();
      syncFromCart();
      return true;
    }
    return false;
  }

  // ─── Modal ──────────────────────────────────────────────────
  /**
   * A fixed overlay is laid out against the layout viewport, which on a phone extends behind
   * the address and tool bars — so the foot of the popup, Apply button included, ends up
   * under the browser chrome and cannot be scrolled to. visualViewport reports the area that
   * is really visible, so the overlay is sized from that whenever the browser provides it.
   */
  function sizeModalToViewport() {
    const overlay = document.getElementById('gb-modal-overlay');
    if (!overlay) return;
    const vv = window.visualViewport;
    const height = vv ? vv.height : window.innerHeight;
    if (!height) return;
    overlay.style.height = height + 'px';
    overlay.style.setProperty('--gb-modal-max-h', Math.max(160, height - 32) + 'px');
  }

  function bindModalViewportSizing() {
    sizeModalToViewport();
    window.addEventListener('resize', sizeModalToViewport);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', sizeModalToViewport);
      window.visualViewport.addEventListener('scroll', sizeModalToViewport);
    }
  }

  function unbindModalViewportSizing() {
    window.removeEventListener('resize', sizeModalToViewport);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', sizeModalToViewport);
      window.visualViewport.removeEventListener('scroll', sizeModalToViewport);
    }
  }

  function openModal() {
    if (document.getElementById('gb-modal-overlay')) return;
    const formBlock = document.getElementById(FORM_BLOCK_ID);
    if (!formBlock) return;

    injectModalStyles();

    const overlay = document.createElement('div');
    overlay.id = 'gb-modal-overlay';
    const box = document.createElement('div');
    box.id = 'gb-modal-box';
    const closeBtn = document.createElement('button');
    closeBtn.id = 'gb-modal-close';
    closeBtn.textContent = '✕';
    closeBtn.addEventListener('click', closeModal);

    suppressApplyFromRadio = true;
    box.appendChild(closeBtn);
    box.appendChild(formBlock);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    scheduleTranslateGloboPopup(formBlock);
    ensurePopupSubtotal();

    overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
    bindModalViewportSizing();
    document.body.style.overflow = 'hidden';
    // Do not call attachListeners() here: it used to reset listenersAttached and re-bind
    // Globo radios, which fired a spurious Apply change when the block was reparented and
    // immediately invoked showPriceSummary() → closeModal().
    calculate();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        suppressApplyFromRadio = false;
      });
    });
  }

  function closeModal() {
    const overlay   = document.getElementById('gb-modal-overlay');
    const formBlock = document.getElementById(FORM_BLOCK_ID);

    if (formBlock && overlay) {
      overlay.before(formBlock);
      formBlock.style.display = 'none';
    }
    if (overlay) overlay.remove();
    unbindModalViewportSizing();
    document.body.style.overflow = '';

    const summary = document.getElementById('gb-price-summary');
    const toggle  = document.getElementById('popupToggle');
    if (toggle && !summary) toggle.checked = false;

    listenersAttached = false;
  }

  // ─── Toggle Listener ────────────────────────────────────────
  document.addEventListener('change', function (e) {
    if (e.target.id === 'popupToggle') {
      const formBlock = document.getElementById(FORM_BLOCK_ID);
      if (!formBlock) return;

      if (e.target.checked) {
        formBlock.style.display = 'block';
        openModal();
      } else {
        const summary = document.getElementById('gb-price-summary');
        if (summary) {
          e.target.checked = true;
          formBlock.style.display = 'block';
          openModal();
        } else {
          closeModal();
        }
      }
    }
  });

  // ─── Intercept Cart Submit ──────────────────────────────────
  (function() {
    function syncCartAddFormProperties() {
      document.addEventListener('submit', function (e) {
        const form = e.target;
        if (!(form instanceof HTMLFormElement)) return;
        const act = form.getAttribute('action') || '';
        if (act.indexOf('cart') === -1 || act.indexOf('add') === -1) return;

        const summaryEl = document.getElementById('gb-price-summary');
        const logoPriceInput = form.querySelector('[name="properties[logo-price]"]');
        if (logoPriceInput && !summaryEl) logoPriceInput.value = '0';
        if (summaryEl) processGbAddonInput(form);

        const gbVal = goldBlockingCartPropertyValue();
        const formPropName = gbCartPropertyFormName();
        let gbInput = null;
        Array.prototype.forEach.call(form.querySelectorAll('input'), function (inp) {
          if (inp.name === formPropName) gbInput = inp;
        });
        if (gbVal === null) {
          if (gbInput) gbInput.remove();
        } else {
          if (!gbInput) {
            gbInput = document.createElement('input');
            gbInput.type = 'hidden';
            gbInput.name = formPropName;
            form.appendChild(gbInput);
          }
          gbInput.value = gbVal;
        }
      }, true);
    }

    function patchFetch() {
      const _fetch = window.fetch;
      window.fetch = function(url, options) {
        if (typeof url === 'string' && url.includes('/cart/add') && options && options.body) {
          try {
            const summaryEl = document.getElementById('gb-price-summary');
            if (typeof options.body === 'string') {
              const params = new URLSearchParams(options.body);
              if (!summaryEl && params.has('properties[logo-price]')) {
                params.set('properties[logo-price]', '0');
              }
              if (summaryEl) applyGbAddonToUrlParams(params);
              applyGoldBlockingTotalToUrlParams(params);
              options.body = params.toString();
            } else if (options.body instanceof FormData) {
              if (!summaryEl && options.body.has('properties[logo-price]')) {
                options.body.set('properties[logo-price]', '0');
              }
              if (summaryEl) applyGbAddonToFormData(options.body);
              applyGoldBlockingTotalToFormData(options.body);
            }
          } catch (err) { console.log('[GB] fetch patch error:', err); }
        }
        const hadGoldBlockingApplied = !!document.getElementById('gb-price-summary');
        return _fetch.apply(this, arguments).then(function (res) {
          if (
            hadGoldBlockingApplied &&
            typeof url === 'string' &&
            url.includes('/cart/add') &&
            res.ok
          ) {
            res.clone().json().then(function (data) {
              if (data && !data.status) {
                setTimeout(clearGoldBlockingForNewLine, 150);
              }
            }).catch(function () {});
          }
          return res;
        });
      };
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { syncCartAddFormProperties(); patchFetch(); });
    } else {
      syncCartAddFormProperties();
      patchFetch();
    }
  })();

  // ─── Init ───────────────────────────────────────────────────
  function init() {
    injectStyles();
    setupCartAddReset();
    setupDelegatedSwatchListeners();
    setupDeCartCurrencyDisplay();
    setupProductPriceVatPersistence();
    setupQuantityWatch();
    if (hasGoldBlockingProduct()) {
      resetGloboAddonTotal();
      setTimeout(resetGloboAddonTotal, 400);
    }
    watchGloboTranslations();
    if (attachListeners()) return;
    let tries = 0;
    const t = setInterval(function () {
      tries++;
      const formBlock = document.getElementById(FORM_BLOCK_ID);
      if (formBlock) {
        watchGloboTranslations();
        scheduleTranslateGloboPopup(formBlock);
      }
      if (attachListeners() || tries >= 20) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.goldBlockingUi = {
    isApplyControlText: isApplyControlText,
    isApplyRadioValue: isApplyRadioValue,
    isCancelControlText: isCancelControlText,
    isCancelRadioValue: isCancelRadioValue,
    formatGbMoney: formatGbMoney,
    processGbAddonInput: processGbAddonInput,
    updateGbPriceSummaryTotal: updateGbPriceSummaryTotal
  };

})();